import { Option, SelectedItems } from "@/types/productTypes";
import { Box, useRadioGroup, VStack } from "@chakra-ui/react";
import RadioButtonItem from "./RadioButtonItem";
import { useOptionConfig } from "../../hooks/useOptionConfig";
import { useTranslation } from "@/hooks/use-translation";

// RadioOption.tsx

type RadioOptionProps = {
   option: Option;
   dependecies: SelectedItems[];
};

export default function RadioOption({ option }: RadioOptionProps) {
   const { translate } = useTranslation();
   const defaultValue = {
      selectedItem:
         (option.items?.length &&
            option.defaultValue &&
            option.defaultValue.toString()) ||
         "-1",
      selected: true,
   };
   console.log("optionsDefault", defaultValue);
   const { fieldValue, handleChange } = useOptionConfig(option, defaultValue);
   // Chakra UI's useRadioGroup. We'll pass `handleChange` to `onChange`.
   const { getRootProps, getRadioProps } = useRadioGroup({
      value: fieldValue?.selectedItem as string,
      onChange: (value) => {
         handleChange(value); // Sync with react-hook-form
      },
   });
   console.log("optionOnly", option);

   return (
      <Box mb="1.5rem">
         <h3 className="text-d-body-h3 text-custom-dark">
            {translate(option)}
         </h3>
         <VStack align="stretch" spacing={4} mt={"1.5rem"} {...getRootProps()}>
            {option.items?.map((item, index) => {
               const radio = getRadioProps({ value: item.id?.toString() });
               return (
                  <RadioButtonItem
                     index={index}
                     key={index}
                     item={item}
                     controlValue={fieldValue}
                     radio={radio}
                  />
               );
            })}
         </VStack>
      </Box>
   );
}
